import { render } from "./DetailItem.vue?vue&type=template&id=34552b3e&scoped=true"
import script from "./DetailItem.vue?vue&type=script&lang=js"
export * from "./DetailItem.vue?vue&type=script&lang=js"

import "./DetailItem.vue?vue&type=style&index=0&id=34552b3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34552b3e"]])

export default __exports__